import React, { FC } from 'react';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import { PartListOrSingleItem } from '@v2/pages/machines/modules/now/components/Part/components/PartListOrSingleItem';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';

interface JobDetailsPartProps {
  partId: number | null;
}

const JobDetailsPartComponent: FC<JobDetailsPartProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  partId,
}) => {
  const title = useTitle();

  useJobDetails({
    operationsSearch,
    updateHeaderConfig,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
  });

  return (
    <JobContentWrapper loading={false} title={title.part}>
        <PartListOrSingleItem partId={partId} />
    </JobContentWrapper>
  );
};

const JobDetailsPart = connect(({ details: { partId } }) => ({ partId }), {
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
})(JobDetailsPartComponent);

export { JobDetailsPart };
